import { getUpgradeCurrentReplaceValueById } from "@/game/utils/upgrades";
import { FrameName } from "../config";
import { ResourceType } from "../config/resources";
import { UpgradeIds } from "../config/upgrades";
import TileEntity from "../TileEntity";

class MarketBuildingTileEntity extends TileEntity {
	public static readonly frameName = FrameName.MARKET;

	public get consumption(): Map<ResourceType, number> {
		const consumption = new Map<ResourceType, number>(super.consumption);

		let goodsConsumption =
			(consumption.get(ResourceType.GOODS_CONSUMPTION) as number) || 0;
		goodsConsumption *=
			1 - getUpgradeCurrentReplaceValueById(UpgradeIds.free_market);
		consumption.set(ResourceType.GOODS_CONSUMPTION, goodsConsumption);

		return consumption;
	}
}

export default MarketBuildingTileEntity;
